export default "__VITE_ASSET__BOIlkZXo__"